// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Barlow+Condensed:wght@600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Group members overview dialog — brand + light/dark */

.gmd-dlg {
  --gmd-accent: var(--brand-primary, #0877BC);
  --gmd-accent-2: var(--brand-secondary, #46528b);
}

/* Club colors lifted toward white so dark palettes stay readable on dark surfaces. */
.dark-mode .gmd-dlg,
html[data-theme="dark"] .gmd-dlg {
  --gmd-accent: color-mix(in srgb, var(--brand-primary, #0877BC) 62%, #fff);
  --gmd-accent-2: color-mix(in srgb, var(--brand-secondary, #46528b) 55%, #fff);
}

.gmd-dlg.MuiDialog-root .MuiDialog-paper,
.gmd-dlg .MuiDialog-paper {
  border-radius: 20px !important;
  overflow: hidden;
  background: var(--surface-color, var(--bg-color, #fff)) !important;
  color: var(--text-color, #1a1a1a) !important;
  max-height: min(92vh, 880px);
  border: 1px solid var(--border-color, rgba(0, 0, 0, 0.08));
  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.18);
}

.dark-mode .gmd-dlg .MuiDialog-paper {
  border-color: rgba(255, 255, 255, 0.1);
  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.55);
}

/* Compact layout: one-line header bar, the roster scroll takes the rest. */
.gmd-dlg--compact .MuiDialog-paper {
  --gmd-display: "Barlow Condensed", "Arial Narrow", Impact, sans-serif;
  display: flex;
  flex-direction: column;
}

.gmd-dlg--compact .gmd-dlg__body {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0;
}

.gmd-dlg--compact .gmd-dlg__scroll {
  flex: 1 1 auto;
  min-height: 0;
  max-height: none;
  padding: 0 20px 18px;
  overscroll-behavior: contain;
}

.gmd-dlg--compact .gmd-dlg__loading {
  flex: 1 1 auto;
}

/* Section labels stay pinned while the roster scrolls under them. */
.gmd-dlg--compact .gmd-dlg__section-head {
  position: sticky;
  top: 0;
  z-index: 1;
  margin: 0 0 8px;
  padding: 12px 0 8px;
  background: var(--surface-color, var(--bg-color, #fff));
}

.gmd-dlg--compact .gmd-dlg__section {
  margin-bottom: 10px;
}

.gmd-bar {
  position: relative;
  flex: 0 0 auto;
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto auto;
  align-items: center;
  gap: 14px;
  padding: 10px 12px 10px 16px;
  background:
    linear-gradient(
      90deg,
      rgba(var(--brand-primary-rgb, 8, 119, 188), 0.1) 0%,
      rgba(var(--brand-primary-rgb, 8, 119, 188), 0.02) 60%,
      transparent 100%
    ),
    var(--surface-color, var(--bg-color, #fff));
  border-bottom: 2px solid rgba(var(--brand-primary-rgb, 8, 119, 188), 0.28);
}

.gmd-bar__id {
  display: flex;
  align-items: center;
  gap: 11px;
  min-width: 0;
}

.gmd-bar__avatar {
  width: 40px;
  height: 40px;
  border-radius: 11px;
  object-fit: cover;
  flex-shrink: 0;
  border: 2px solid rgba(var(--brand-primary-rgb, 8, 119, 188), 0.35);
  background: var(--bg-color, #f4f5f6);
}

.gmd-bar__avatar--fallback {
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: var(--gmd-display);
  font-size: 1.25rem;
  font-weight: 700;
  color: #fff;
  border: none;
  background: linear-gradient(
    135deg,
    var(--brand-primary, #0877BC),
    var(--brand-primary-light, #0a8cd8)
  );
}

.gmd-bar__text {
  min-width: 0;
}

.gmd-bar__club {
  display: flex;
  align-items: center;
  gap: 5px;
  margin: 0;
  font-size: 0.62rem;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--gmd-accent);
  line-height: 1.3;
}

.gmd-bar__club span {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.gmd-bar__club img {
  width: auto;
  max-width: 16px;
  max-height: 16px;
  object-fit: contain;
}

.gmd-bar__title {
  margin: 0;
  font-family: var(--gmd-display);
  font-size: 1.45rem;
  font-weight: 700;
  letter-spacing: 0.01em;
  line-height: 1.05;
  color: var(--text-color, #111);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

/* Scoreboard tally: number over label, split by hairlines. */
.gmd-bar__tally {
  display: flex;
  align-items: stretch;
  margin: 0;
  border: 1px solid rgba(var(--brand-primary-rgb, 8, 119, 188), 0.2);
  border-radius: 10px;
  background: var(--surface-color, var(--bg-color, #fff));
  overflow: hidden;
}

.gmd-bar__tally-cell {
  display: flex;
  flex-direction: column-reverse;
  align-items: center;
  justify-content: center;
  min-width: 58px;
  padding: 4px 10px 5px;
}

.gmd-bar__tally-cell + .gmd-bar__tally-cell {
  border-left: 1px solid rgba(var(--brand-primary-rgb, 8, 119, 188), 0.16);
}

.gmd-bar__tally dd {
  margin: 0;
  font-family: var(--gmd-display);
  font-size: 1.4rem;
  font-weight: 700;
  line-height: 1;
  font-variant-numeric: tabular-nums;
  color: var(--gmd-accent);
}

.gmd-bar__tally dt {
  margin-top: 2px;
  font-size: 0.58rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--text-secondary, #666);
  white-space: nowrap;
}

.gmd-bar__tally-cell--muted dd {
  color: var(--text-secondary, #666);
}

.dark-mode .gmd-bar {
  border-bottom-color: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.4);
}

.dark-mode .gmd-bar__tally {
  border-color: rgba(255, 255, 255, 0.12);
  background: rgba(255, 255, 255, 0.03);
}

.dark-mode .gmd-bar__tally-cell + .gmd-bar__tally-cell {
  border-left-color: rgba(255, 255, 255, 0.1);
}

.gmd-bar .gmd-dlg__header-actions {
  position: static;
}

@media (max-width: 600px) {
  .gmd-dlg--compact .MuiDialog-paper {
    margin: 12px;
    width: calc(100% - 24px);
    max-height: calc(100% - 24px);
  }

  .gmd-bar {
    grid-template-columns: minmax(0, 1fr) auto;
    grid-template-areas:
      "id actions"
      "tally tally";
    gap: 8px 10px;
    padding: 10px 10px 10px 14px;
  }

  .gmd-bar__id {
    grid-area: id;
  }

  .gmd-bar__tally {
    grid-area: tally;
  }

  .gmd-bar .gmd-dlg__header-actions {
    grid-area: actions;
  }

  .gmd-bar__tally-cell {
    flex: 1 1;
    flex-direction: row-reverse;
    gap: 6px;
    padding: 5px 8px;
  }

  .gmd-bar__tally dd {
    font-size: 1.15rem;
  }

  .gmd-bar__tally dt {
    margin-top: 0;
  }

  .gmd-dlg--compact .gmd-dlg__scroll {
    padding: 0 14px 14px;
  }
}

.gmd-dlg__header-actions {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 1;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.gmd-dlg__header-actions .gmd-dlg__close,
.gmd-dlg__header-actions .gmd-dlg__add-session {
  position: static !important;
}

.gmd-dlg__close,
.gmd-dlg__add-session {
  color: var(--text-secondary, #666) !important;
  background: rgba(0, 0, 0, 0.04) !important;
}

.dark-mode .gmd-dlg__close,
.dark-mode .gmd-dlg__add-session {
  background: rgba(255, 255, 255, 0.06) !important;
  color: var(--text-secondary, #aaa) !important;
}

.gmd-dlg__close:hover,
.gmd-dlg__add-session:hover {
  background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.12) !important;
  color: var(--gmd-accent) !important;
}

.gmd-dlg__body {
  padding: 0 !important;
  overflow: hidden;
}

.gmd-dlg__scroll {
  overflow-y: auto;
  max-height: min(62vh, 560px);
  padding: 18px 20px 8px;
  animation: gmdFade 0.28s ease;
}

@keyframes gmdFade {
  from {
    opacity: 0;
    transform: translateY(6px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.gmd-dlg__loading,
.gmd-dlg__empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  min-height: 200px;
  color: var(--text-secondary, #888);
  text-align: center;
  padding: 24px;
}

.gmd-dlg__section {
  margin-bottom: 20px;
}

.gmd-dlg__section:last-child {
  margin-bottom: 8px;
}

.gmd-dlg__section-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 12px;
}

.gmd-dlg__section-title {
  margin: 0;
  font-size: 0.7rem;
  font-weight: 750;
  letter-spacing: 0.07em;
  text-transform: uppercase;
  color: var(--text-secondary, #666);
  display: flex;
  align-items: center;
  gap: 8px;
}

.gmd-dlg__section-title svg {
  font-size: 16px !important;
  color: var(--gmd-accent);
}

.gmd-dlg__count {
  font-size: 0.7rem;
  font-weight: 700;
  color: var(--gmd-accent);
  background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.1);
  padding: 2px 8px;
  border-radius: 999px;
}

/* Goals */
.gmd-dlg__goals-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 14px;
}

@media (max-width: 700px) {
  .gmd-dlg__goals-grid {
    grid-template-columns: 1fr;
  }
}

.gmd-dlg__goals-col {
  background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.04);
  border: 1px solid rgba(var(--brand-primary-rgb, 8, 119, 188), 0.12);
  border-radius: 14px;
  padding: 12px 14px;
}

.gmd-dlg__goals-col--secondary {
  background: rgba(0, 0, 0, 0.02);
  border-color: var(--border-color, rgba(0, 0, 0, 0.08));
}

.dark-mode .gmd-dlg__goals-col--secondary {
  background: rgba(255, 255, 255, 0.03);
  border-color: rgba(255, 255, 255, 0.1);
}

.gmd-dlg__goals-col-title {
  margin: 0 0 10px;
  font-size: 0.78rem;
  font-weight: 700;
  color: var(--gmd-accent);
}

.gmd-dlg__goals-col--secondary .gmd-dlg__goals-col-title {
  color: var(--gmd-accent-2);
}

.gmd-dlg__goal {
  display: grid;
  grid-template-columns: 28px 1fr auto;
  align-items: center;
  gap: 10px;
  padding: 9px 10px;
  margin-bottom: 6px;
  border-radius: 10px;
  background: var(--surface-color, var(--bg-color, #fff));
  border: 1px solid var(--border-color, rgba(0, 0, 0, 0.06));
  transition: border-color 0.15s ease, transform 0.15s ease;
}

.gmd-dlg__goal:last-child {
  margin-bottom: 0;
}

.gmd-dlg__goal:hover {
  border-color: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.3);
  transform: translateY(-1px);
}

.gmd-dlg__goal-rank {
  width: 28px;
  height: 28px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.75rem;
  font-weight: 800;
  color: #fff;
  background: linear-gradient(
    135deg,
    var(--brand-primary, #0877BC),
    var(--brand-primary-light, #0a8cd8)
  );
}

.gmd-dlg__goals-col--secondary .gmd-dlg__goal-rank {
  background: linear-gradient(
    135deg,
    var(--brand-secondary, #46528b),
    color-mix(in srgb, var(--brand-secondary, #46528b) 70%, #fff)
  );
}

.gmd-dlg__goal-label {
  font-size: 0.85rem;
  font-weight: 600;
  color: var(--text-color, #222);
  line-height: 1.3;
  min-width: 0;
}

.gmd-dlg__goal-count {
  min-width: 28px;
  height: 24px;
  padding: 0 8px;
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 0.72rem;
  font-weight: 800;
  color: var(--gmd-accent);
  background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.12);
}

.gmd-dlg__goals-col--secondary .gmd-dlg__goal-count {
  color: var(--gmd-accent-2);
  background: color-mix(in srgb, var(--brand-secondary, #46528b) 14%, transparent);
}

.gmd-dlg__hint {
  margin: 10px 0 0;
  font-size: 0.75rem;
  color: var(--text-secondary, #888);
}

.gmd-dlg__muted {
  margin: 0;
  font-size: 0.82rem;
  color: var(--text-secondary, #888);
  padding: 6px 2px;
}

/* People grids */
.gmd-dlg__people {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 10px;
}

.gmd-dlg__person {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 11px 12px;
  border-radius: 14px;
  border: 1px solid var(--border-color, rgba(0, 0, 0, 0.08));
  background: rgba(0, 0, 0, 0.015);
  transition: border-color 0.2s ease, background 0.2s ease, transform 0.2s ease;
}

.dark-mode .gmd-dlg__person {
  background: rgba(255, 255, 255, 0.03);
  border-color: rgba(255, 255, 255, 0.1);
}

.gmd-dlg__person:hover {
  transform: translateY(-1px);
  border-color: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.3);
  background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.05);
}

.gmd-dlg__person--coach:hover {
  border-color: color-mix(in srgb, var(--brand-secondary, #46528b) 45%, transparent);
  background: color-mix(in srgb, var(--brand-secondary, #46528b) 8%, transparent);
}

.gmd-dlg__person-avatar {
  width: 42px;
  height: 42px;
  border-radius: 12px;
  object-fit: cover;
  flex-shrink: 0;
  border: 2px solid rgba(var(--brand-primary-rgb, 8, 119, 188), 0.25);
}

.gmd-dlg__person-avatar--fallback {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.8rem;
  font-weight: 800;
  color: #fff;
  background: linear-gradient(
    135deg,
    var(--brand-primary, #0877BC),
    var(--brand-primary-light, #0a8cd8)
  );
  border: none;
}

.gmd-dlg__person--coach .gmd-dlg__person-avatar {
  border-color: color-mix(in srgb, var(--brand-secondary, #46528b) 40%, transparent);
}

.gmd-dlg__person--coach .gmd-dlg__person-avatar--fallback {
  background: linear-gradient(
    135deg,
    var(--brand-secondary, #46528b),
    color-mix(in srgb, var(--brand-secondary, #46528b) 65%, #fff)
  );
}

.gmd-dlg__person-body {
  min-width: 0;
  flex: 1 1;
}

.gmd-dlg__person-name {
  margin: 0;
  font-size: 0.88rem;
  font-weight: 650;
  color: var(--text-color, #222);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.gmd-dlg__person-meta {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  margin-top: 4px;
}

.gmd-dlg__badge {
  display: inline-flex;
  align-items: center;
  height: 20px;
  padding: 0 8px;
  border-radius: 999px;
  font-size: 0.65rem;
  font-weight: 750;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: var(--gmd-accent);
  background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.12);
}

.gmd-dlg__badge--coach {
  color: var(--gmd-accent-2);
  background: color-mix(in srgb, var(--brand-secondary, #46528b) 14%, transparent);
}

.gmd-dlg__classement {
  font-size: 0.68rem;
  font-weight: 700;
  color: var(--text-secondary, #666);
}

.gmd-dlg__footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 12px 18px !important;
  border-top: 1px solid var(--border-color, rgba(0, 0, 0, 0.08)) !important;
  background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.03);
}

.dark-mode .gmd-dlg__footer {
  border-top-color: rgba(255, 255, 255, 0.1) !important;
  background: rgba(255, 255, 255, 0.02);
}

.gmd-dlg__footer-btn {
  text-transform: none !important;
  font-weight: 650 !important;
  border-radius: 10px !important;
  background: var(--brand-primary, #0877BC) !important;
  color: #fff !important;
  padding: 8px 18px !important;
}

.gmd-dlg__footer-btn:hover {
  background: var(--brand-primary-dark, #065a8f) !important;
}

@media (max-width: 540px) {
  .gmd-dlg__scroll {
    padding: 14px;
  }

  .gmd-dlg__people {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/GroupMembersOverviewDialog.css"],"names":[],"mappings":"AAEA,uDAAuD;;AAEvD;EACE,2CAA2C;EAC3C,+CAA+C;AACjD;;AAEA,qFAAqF;AACrF;;EAEE,yEAAyE;EACzE,6EAA6E;AAC/E;;AAEA;;EAEE,8BAA8B;EAC9B,gBAAgB;EAChB,kEAAkE;EAClE,4CAA4C;EAC5C,4BAA4B;EAC5B,0DAA0D;EAC1D,2CAA2C;AAC7C;;AAEA;EACE,sCAAsC;EACtC,2CAA2C;AAC7C;;AAEA,2EAA2E;AAC3E;EACE,qEAAqE;EACrE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,oBAAoB;EACpB,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA,oEAAoE;AACpE;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,eAAe;EACf,mBAAmB;EACnB,uDAAuD;AACzD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,+CAA+C;EAC/C,mBAAmB;EACnB,SAAS;EACT,4BAA4B;EAC5B;;;;;;;+CAO6C;EAC7C,0EAA0E;AAC5E;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,mEAAmE;EACnE,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ;;;;GAIC;AACH;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;EACjB,8BAA8B;EAC9B,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,6DAA6D;AAC7D;EACE,aAAa;EACb,oBAAoB;EACpB,SAAS;EACT,kEAAkE;EAClE,mBAAmB;EACnB,uDAAuD;EACvD,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,wEAAwE;AAC1E;;AAEA;EACE,SAAS;EACT,+BAA+B;EAC/B,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kCAAkC;EAClC,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,qEAAqE;AACvE;;AAEA;EACE,uCAAuC;EACvC,qCAAqC;AACvC;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,YAAY;IACZ,wBAAwB;IACxB,6BAA6B;EAC/B;;EAEA;IACE,0CAA0C;IAC1C;;mBAEe;IACf,aAAa;IACb,4BAA4B;EAC9B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,SAAW;IACX,2BAA2B;IAC3B,QAAQ;IACR,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;;EAEE,6CAA6C;EAC7C,0CAA0C;AAC5C;;AAEA;;EAEE,gDAAgD;EAChD,6CAA6C;AAC/C;;AAEA;;EAEE,wEAAwE;EACxE,mCAAmC;AACrC;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,iBAAiB;EACjB,kCAAkC;EAClC,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,0BAA0B;EAC1B,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;EACxB,4DAA4D;EAC5D,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA,UAAU;AACV;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,6DAA6D;EAC7D,mEAAmE;EACnE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,sDAAsD;AACxD;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;AACxC;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,uDAAuD;EACvD,0DAA0D;EAC1D,yDAAyD;AAC3D;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,8DAA8D;EAC9D,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX;;;;GAIC;AACH;;AAEA;EACE;;;;GAIC;AACH;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,8BAA8B;EAC9B,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,6DAA6D;AAC/D;;AAEA;EACE,0BAA0B;EAC1B,gFAAgF;AAClF;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,0DAA0D;EAC1D,gCAAgC;EAChC,6EAA6E;AAC/E;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;AACxC;;AAEA;EACE,2BAA2B;EAC3B,8DAA8D;EAC9D,6DAA6D;AAC/D;;AAEA;EACE,kFAAkF;EAClF,+EAA+E;AACjF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,mEAAmE;AACrE;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX;;;;GAIC;EACD,YAAY;AACd;;AAEA;EACE,kFAAkF;AACpF;;AAEA;EACE;;;;GAIC;AACH;;AAEA;EACE,YAAY;EACZ,SAAO;AACT;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;EACxB,6DAA6D;AAC/D;;AAEA;EACE,0BAA0B;EAC1B,gFAAgF;AAClF;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;EACR,6BAA6B;EAC7B,yEAAyE;EACzE,6DAA6D;AAC/D;;AAEA;EACE,qDAAqD;EACrD,qCAAqC;AACvC;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,8BAA8B;EAC9B,oDAAoD;EACpD,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,yDAAyD;AAC3D;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Barlow+Condensed:wght@600;700&display=swap\");\n\n/* Group members overview dialog — brand + light/dark */\n\n.gmd-dlg {\n  --gmd-accent: var(--brand-primary, #0877BC);\n  --gmd-accent-2: var(--brand-secondary, #46528b);\n}\n\n/* Club colors lifted toward white so dark palettes stay readable on dark surfaces. */\n.dark-mode .gmd-dlg,\nhtml[data-theme=\"dark\"] .gmd-dlg {\n  --gmd-accent: color-mix(in srgb, var(--brand-primary, #0877BC) 62%, #fff);\n  --gmd-accent-2: color-mix(in srgb, var(--brand-secondary, #46528b) 55%, #fff);\n}\n\n.gmd-dlg.MuiDialog-root .MuiDialog-paper,\n.gmd-dlg .MuiDialog-paper {\n  border-radius: 20px !important;\n  overflow: hidden;\n  background: var(--surface-color, var(--bg-color, #fff)) !important;\n  color: var(--text-color, #1a1a1a) !important;\n  max-height: min(92vh, 880px);\n  border: 1px solid var(--border-color, rgba(0, 0, 0, 0.08));\n  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.18);\n}\n\n.dark-mode .gmd-dlg .MuiDialog-paper {\n  border-color: rgba(255, 255, 255, 0.1);\n  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.55);\n}\n\n/* Compact layout: one-line header bar, the roster scroll takes the rest. */\n.gmd-dlg--compact .MuiDialog-paper {\n  --gmd-display: \"Barlow Condensed\", \"Arial Narrow\", Impact, sans-serif;\n  display: flex;\n  flex-direction: column;\n}\n\n.gmd-dlg--compact .gmd-dlg__body {\n  display: flex;\n  flex-direction: column;\n  flex: 1 1 auto;\n  min-height: 0;\n}\n\n.gmd-dlg--compact .gmd-dlg__scroll {\n  flex: 1 1 auto;\n  min-height: 0;\n  max-height: none;\n  padding: 0 20px 18px;\n  overscroll-behavior: contain;\n}\n\n.gmd-dlg--compact .gmd-dlg__loading {\n  flex: 1 1 auto;\n}\n\n/* Section labels stay pinned while the roster scrolls under them. */\n.gmd-dlg--compact .gmd-dlg__section-head {\n  position: sticky;\n  top: 0;\n  z-index: 1;\n  margin: 0 0 8px;\n  padding: 12px 0 8px;\n  background: var(--surface-color, var(--bg-color, #fff));\n}\n\n.gmd-dlg--compact .gmd-dlg__section {\n  margin-bottom: 10px;\n}\n\n.gmd-bar {\n  position: relative;\n  flex: 0 0 auto;\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) auto auto;\n  align-items: center;\n  gap: 14px;\n  padding: 10px 12px 10px 16px;\n  background:\n    linear-gradient(\n      90deg,\n      rgba(var(--brand-primary-rgb, 8, 119, 188), 0.1) 0%,\n      rgba(var(--brand-primary-rgb, 8, 119, 188), 0.02) 60%,\n      transparent 100%\n    ),\n    var(--surface-color, var(--bg-color, #fff));\n  border-bottom: 2px solid rgba(var(--brand-primary-rgb, 8, 119, 188), 0.28);\n}\n\n.gmd-bar__id {\n  display: flex;\n  align-items: center;\n  gap: 11px;\n  min-width: 0;\n}\n\n.gmd-bar__avatar {\n  width: 40px;\n  height: 40px;\n  border-radius: 11px;\n  object-fit: cover;\n  flex-shrink: 0;\n  border: 2px solid rgba(var(--brand-primary-rgb, 8, 119, 188), 0.35);\n  background: var(--bg-color, #f4f5f6);\n}\n\n.gmd-bar__avatar--fallback {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-family: var(--gmd-display);\n  font-size: 1.25rem;\n  font-weight: 700;\n  color: #fff;\n  border: none;\n  background: linear-gradient(\n    135deg,\n    var(--brand-primary, #0877BC),\n    var(--brand-primary-light, #0a8cd8)\n  );\n}\n\n.gmd-bar__text {\n  min-width: 0;\n}\n\n.gmd-bar__club {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  margin: 0;\n  font-size: 0.62rem;\n  font-weight: 700;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  color: var(--gmd-accent);\n  line-height: 1.3;\n}\n\n.gmd-bar__club span {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n.gmd-bar__club img {\n  width: auto;\n  max-width: 16px;\n  max-height: 16px;\n  object-fit: contain;\n}\n\n.gmd-bar__title {\n  margin: 0;\n  font-family: var(--gmd-display);\n  font-size: 1.45rem;\n  font-weight: 700;\n  letter-spacing: 0.01em;\n  line-height: 1.05;\n  color: var(--text-color, #111);\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n/* Scoreboard tally: number over label, split by hairlines. */\n.gmd-bar__tally {\n  display: flex;\n  align-items: stretch;\n  margin: 0;\n  border: 1px solid rgba(var(--brand-primary-rgb, 8, 119, 188), 0.2);\n  border-radius: 10px;\n  background: var(--surface-color, var(--bg-color, #fff));\n  overflow: hidden;\n}\n\n.gmd-bar__tally-cell {\n  display: flex;\n  flex-direction: column-reverse;\n  align-items: center;\n  justify-content: center;\n  min-width: 58px;\n  padding: 4px 10px 5px;\n}\n\n.gmd-bar__tally-cell + .gmd-bar__tally-cell {\n  border-left: 1px solid rgba(var(--brand-primary-rgb, 8, 119, 188), 0.16);\n}\n\n.gmd-bar__tally dd {\n  margin: 0;\n  font-family: var(--gmd-display);\n  font-size: 1.4rem;\n  font-weight: 700;\n  line-height: 1;\n  font-variant-numeric: tabular-nums;\n  color: var(--gmd-accent);\n}\n\n.gmd-bar__tally dt {\n  margin-top: 2px;\n  font-size: 0.58rem;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--text-secondary, #666);\n  white-space: nowrap;\n}\n\n.gmd-bar__tally-cell--muted dd {\n  color: var(--text-secondary, #666);\n}\n\n.dark-mode .gmd-bar {\n  border-bottom-color: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.4);\n}\n\n.dark-mode .gmd-bar__tally {\n  border-color: rgba(255, 255, 255, 0.12);\n  background: rgba(255, 255, 255, 0.03);\n}\n\n.dark-mode .gmd-bar__tally-cell + .gmd-bar__tally-cell {\n  border-left-color: rgba(255, 255, 255, 0.1);\n}\n\n.gmd-bar .gmd-dlg__header-actions {\n  position: static;\n}\n\n@media (max-width: 600px) {\n  .gmd-dlg--compact .MuiDialog-paper {\n    margin: 12px;\n    width: calc(100% - 24px);\n    max-height: calc(100% - 24px);\n  }\n\n  .gmd-bar {\n    grid-template-columns: minmax(0, 1fr) auto;\n    grid-template-areas:\n      \"id actions\"\n      \"tally tally\";\n    gap: 8px 10px;\n    padding: 10px 10px 10px 14px;\n  }\n\n  .gmd-bar__id {\n    grid-area: id;\n  }\n\n  .gmd-bar__tally {\n    grid-area: tally;\n  }\n\n  .gmd-bar .gmd-dlg__header-actions {\n    grid-area: actions;\n  }\n\n  .gmd-bar__tally-cell {\n    flex: 1 1 0;\n    flex-direction: row-reverse;\n    gap: 6px;\n    padding: 5px 8px;\n  }\n\n  .gmd-bar__tally dd {\n    font-size: 1.15rem;\n  }\n\n  .gmd-bar__tally dt {\n    margin-top: 0;\n  }\n\n  .gmd-dlg--compact .gmd-dlg__scroll {\n    padding: 0 14px 14px;\n  }\n}\n\n.gmd-dlg__header-actions {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  z-index: 1;\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.gmd-dlg__header-actions .gmd-dlg__close,\n.gmd-dlg__header-actions .gmd-dlg__add-session {\n  position: static !important;\n}\n\n.gmd-dlg__close,\n.gmd-dlg__add-session {\n  color: var(--text-secondary, #666) !important;\n  background: rgba(0, 0, 0, 0.04) !important;\n}\n\n.dark-mode .gmd-dlg__close,\n.dark-mode .gmd-dlg__add-session {\n  background: rgba(255, 255, 255, 0.06) !important;\n  color: var(--text-secondary, #aaa) !important;\n}\n\n.gmd-dlg__close:hover,\n.gmd-dlg__add-session:hover {\n  background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.12) !important;\n  color: var(--gmd-accent) !important;\n}\n\n.gmd-dlg__body {\n  padding: 0 !important;\n  overflow: hidden;\n}\n\n.gmd-dlg__scroll {\n  overflow-y: auto;\n  max-height: min(62vh, 560px);\n  padding: 18px 20px 8px;\n  animation: gmdFade 0.28s ease;\n}\n\n@keyframes gmdFade {\n  from {\n    opacity: 0;\n    transform: translateY(6px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.gmd-dlg__loading,\n.gmd-dlg__empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  min-height: 200px;\n  color: var(--text-secondary, #888);\n  text-align: center;\n  padding: 24px;\n}\n\n.gmd-dlg__section {\n  margin-bottom: 20px;\n}\n\n.gmd-dlg__section:last-child {\n  margin-bottom: 8px;\n}\n\n.gmd-dlg__section-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  margin-bottom: 12px;\n}\n\n.gmd-dlg__section-title {\n  margin: 0;\n  font-size: 0.7rem;\n  font-weight: 750;\n  letter-spacing: 0.07em;\n  text-transform: uppercase;\n  color: var(--text-secondary, #666);\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.gmd-dlg__section-title svg {\n  font-size: 16px !important;\n  color: var(--gmd-accent);\n}\n\n.gmd-dlg__count {\n  font-size: 0.7rem;\n  font-weight: 700;\n  color: var(--gmd-accent);\n  background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.1);\n  padding: 2px 8px;\n  border-radius: 999px;\n}\n\n/* Goals */\n.gmd-dlg__goals-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 14px;\n}\n\n@media (max-width: 700px) {\n  .gmd-dlg__goals-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n.gmd-dlg__goals-col {\n  background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.04);\n  border: 1px solid rgba(var(--brand-primary-rgb, 8, 119, 188), 0.12);\n  border-radius: 14px;\n  padding: 12px 14px;\n}\n\n.gmd-dlg__goals-col--secondary {\n  background: rgba(0, 0, 0, 0.02);\n  border-color: var(--border-color, rgba(0, 0, 0, 0.08));\n}\n\n.dark-mode .gmd-dlg__goals-col--secondary {\n  background: rgba(255, 255, 255, 0.03);\n  border-color: rgba(255, 255, 255, 0.1);\n}\n\n.gmd-dlg__goals-col-title {\n  margin: 0 0 10px;\n  font-size: 0.78rem;\n  font-weight: 700;\n  color: var(--gmd-accent);\n}\n\n.gmd-dlg__goals-col--secondary .gmd-dlg__goals-col-title {\n  color: var(--gmd-accent-2);\n}\n\n.gmd-dlg__goal {\n  display: grid;\n  grid-template-columns: 28px 1fr auto;\n  align-items: center;\n  gap: 10px;\n  padding: 9px 10px;\n  margin-bottom: 6px;\n  border-radius: 10px;\n  background: var(--surface-color, var(--bg-color, #fff));\n  border: 1px solid var(--border-color, rgba(0, 0, 0, 0.06));\n  transition: border-color 0.15s ease, transform 0.15s ease;\n}\n\n.gmd-dlg__goal:last-child {\n  margin-bottom: 0;\n}\n\n.gmd-dlg__goal:hover {\n  border-color: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.3);\n  transform: translateY(-1px);\n}\n\n.gmd-dlg__goal-rank {\n  width: 28px;\n  height: 28px;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.75rem;\n  font-weight: 800;\n  color: #fff;\n  background: linear-gradient(\n    135deg,\n    var(--brand-primary, #0877BC),\n    var(--brand-primary-light, #0a8cd8)\n  );\n}\n\n.gmd-dlg__goals-col--secondary .gmd-dlg__goal-rank {\n  background: linear-gradient(\n    135deg,\n    var(--brand-secondary, #46528b),\n    color-mix(in srgb, var(--brand-secondary, #46528b) 70%, #fff)\n  );\n}\n\n.gmd-dlg__goal-label {\n  font-size: 0.85rem;\n  font-weight: 600;\n  color: var(--text-color, #222);\n  line-height: 1.3;\n  min-width: 0;\n}\n\n.gmd-dlg__goal-count {\n  min-width: 28px;\n  height: 24px;\n  padding: 0 8px;\n  border-radius: 8px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.72rem;\n  font-weight: 800;\n  color: var(--gmd-accent);\n  background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.12);\n}\n\n.gmd-dlg__goals-col--secondary .gmd-dlg__goal-count {\n  color: var(--gmd-accent-2);\n  background: color-mix(in srgb, var(--brand-secondary, #46528b) 14%, transparent);\n}\n\n.gmd-dlg__hint {\n  margin: 10px 0 0;\n  font-size: 0.75rem;\n  color: var(--text-secondary, #888);\n}\n\n.gmd-dlg__muted {\n  margin: 0;\n  font-size: 0.82rem;\n  color: var(--text-secondary, #888);\n  padding: 6px 2px;\n}\n\n/* People grids */\n.gmd-dlg__people {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));\n  gap: 10px;\n}\n\n.gmd-dlg__person {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 11px 12px;\n  border-radius: 14px;\n  border: 1px solid var(--border-color, rgba(0, 0, 0, 0.08));\n  background: rgba(0, 0, 0, 0.015);\n  transition: border-color 0.2s ease, background 0.2s ease, transform 0.2s ease;\n}\n\n.dark-mode .gmd-dlg__person {\n  background: rgba(255, 255, 255, 0.03);\n  border-color: rgba(255, 255, 255, 0.1);\n}\n\n.gmd-dlg__person:hover {\n  transform: translateY(-1px);\n  border-color: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.3);\n  background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.05);\n}\n\n.gmd-dlg__person--coach:hover {\n  border-color: color-mix(in srgb, var(--brand-secondary, #46528b) 45%, transparent);\n  background: color-mix(in srgb, var(--brand-secondary, #46528b) 8%, transparent);\n}\n\n.gmd-dlg__person-avatar {\n  width: 42px;\n  height: 42px;\n  border-radius: 12px;\n  object-fit: cover;\n  flex-shrink: 0;\n  border: 2px solid rgba(var(--brand-primary-rgb, 8, 119, 188), 0.25);\n}\n\n.gmd-dlg__person-avatar--fallback {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.8rem;\n  font-weight: 800;\n  color: #fff;\n  background: linear-gradient(\n    135deg,\n    var(--brand-primary, #0877BC),\n    var(--brand-primary-light, #0a8cd8)\n  );\n  border: none;\n}\n\n.gmd-dlg__person--coach .gmd-dlg__person-avatar {\n  border-color: color-mix(in srgb, var(--brand-secondary, #46528b) 40%, transparent);\n}\n\n.gmd-dlg__person--coach .gmd-dlg__person-avatar--fallback {\n  background: linear-gradient(\n    135deg,\n    var(--brand-secondary, #46528b),\n    color-mix(in srgb, var(--brand-secondary, #46528b) 65%, #fff)\n  );\n}\n\n.gmd-dlg__person-body {\n  min-width: 0;\n  flex: 1;\n}\n\n.gmd-dlg__person-name {\n  margin: 0;\n  font-size: 0.88rem;\n  font-weight: 650;\n  color: var(--text-color, #222);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.gmd-dlg__person-meta {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 6px;\n  margin-top: 4px;\n}\n\n.gmd-dlg__badge {\n  display: inline-flex;\n  align-items: center;\n  height: 20px;\n  padding: 0 8px;\n  border-radius: 999px;\n  font-size: 0.65rem;\n  font-weight: 750;\n  letter-spacing: 0.02em;\n  text-transform: uppercase;\n  color: var(--gmd-accent);\n  background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.12);\n}\n\n.gmd-dlg__badge--coach {\n  color: var(--gmd-accent-2);\n  background: color-mix(in srgb, var(--brand-secondary, #46528b) 14%, transparent);\n}\n\n.gmd-dlg__classement {\n  font-size: 0.68rem;\n  font-weight: 700;\n  color: var(--text-secondary, #666);\n}\n\n.gmd-dlg__footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n  padding: 12px 18px !important;\n  border-top: 1px solid var(--border-color, rgba(0, 0, 0, 0.08)) !important;\n  background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.03);\n}\n\n.dark-mode .gmd-dlg__footer {\n  border-top-color: rgba(255, 255, 255, 0.1) !important;\n  background: rgba(255, 255, 255, 0.02);\n}\n\n.gmd-dlg__footer-btn {\n  text-transform: none !important;\n  font-weight: 650 !important;\n  border-radius: 10px !important;\n  background: var(--brand-primary, #0877BC) !important;\n  color: #fff !important;\n  padding: 8px 18px !important;\n}\n\n.gmd-dlg__footer-btn:hover {\n  background: var(--brand-primary-dark, #065a8f) !important;\n}\n\n@media (max-width: 540px) {\n  .gmd-dlg__scroll {\n    padding: 14px;\n  }\n\n  .gmd-dlg__people {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
